<script setup lang="ts">
import Typography from '@components/Typography.vue';

interface PlusMenuItemProps {
  isActive?: boolean,
  hasPin?: boolean,
}

const { isActive = false, hasPin = false } = defineProps<PlusMenuItemProps>();
</script>

<template>
  <div
    class="plus-menu-item"
    :class="[
      { 'plus-menu-item--active': isActive },
      'rounded-lg',
      'h-14',
      'px-3',
      'flex items-center space-x-2',
      'select-none',
      'cursor-pointer',
    ]"
  >
    <div class="relative flex flex-shrink-0">
      <slot name="icon" />

      <span
        v-if="hasPin"
        class="plus-menu-item__pin"
        :class="[
          'absolute top-0 right-0',
          'rounded-full',
          'w-3 h-3',
        ]"
      />
    </div>

    <Typography
      class="grow"
      :variant="isActive ? 'body-bold' : 'body'"
    >
      <slot name="text" />
    </Typography>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;

.plus-menu-item {
  &--active {
    background-color: $colorBlueLightest;
  }

  @media (hover: hover) {
    &:hover {
      background-color: $colorBlueLightest;
    }
  }

  &__pin {
    background-color: $colorRed;
    border: 1px solid $colorWhite;
  }
}
</style>
